@let viewLabel = getGenericCopy$('payment.view.history') | async;
@let myplansView = getGenericCopy$('myplans.view') | async;
<div class="row" *ngIf="nextPayment">
    <div class="col-12">
        <!-- Next Payment(s) -->
        <div class="d-flex flex-column">
            <div class="d-flex justify-content-between">
                <div class="d-flex flex-column">
                    <div class="gb-body1 heavy mb-2">
                        <p id="p-next-payment" class="mb-0">{{getGenericCopy$('myplans.next.payment.label') | async}}</p>
                    </div>
                </div>
                @if(myplansView && !paymentHistoryRedesign){
                    <div class="gb-body1 heavy">
                        <a
                            (click)="navigateToPaymentMethodPage(myplansView,trackingString('link', [parentPlanName, myplansView]), 'PaymentHistory')"
                            class="gb-icon-button mx-auto"
                            aria-label="View next payment"
                            (keyup.enter)="navigateToPaymentMethodPage(myplansView,trackingString('link', [parentPlanName, myplansView]), 'PaymentHistory')"
                            tabindex="0">
                            {{myplansView}}
                        </a>
                    </div>
                }
            </div>
            <ng-container *ngIf="!hasDataSourcePayment; else dataSourcePayment" >
                <div class="gb-body1 mb-3">
                    <p id="p-billed-on" class="mb-0">{{billedOn}}</p>
                </div>
            </ng-container>
            <ng-template #dataSourcePayment>
                <ng-container *ngFor="let payment of nextPayment?.nextPayments; last as isLast">
                    <div class="gb-body1" [ngClass]="isLast? 'mb-3' : 'mb-6'">
                        <p id="p-billed-on" class="mb-0">
                            {{payment.paymentText}}
                            <span *ngIf="payment.links">
                                <a href="//{{payment.links.url}}" target="_blank" [attr.aria-label]="payment.links.displayText" tabindex="0">{{payment.links.displayText}}</a>
                            </span>
                        </p>
                    </div>
                </ng-container>
            </ng-template>
            <!-- Discount -->
            <div class="d-flex align-items-center" *ngIf="discountPercentage && discountDescription">
                <img [src]="'/content/dam/gmownercenter/gmna/digitalshop/images/icon/discount-tag/discount-tag.png' | link" alt="discount tag">
                <div class="gb-body2 ml-1">
                    <p id="discount-percent" class="mb-0">{{discountPercentage}}</p>
                </div>
                <div class="gb-body2 ml-1">
                    <p id="discount-description" class="mb-0">{{discountDescription}}</p>
                </div>
            </div>
            @if(viewLabel && paymentHistoryRedesign){
                <a class="gb-body2 no-href mt-3" (click)="navigateToPaymentMethodPage(viewLabel,trackingString('link', [parentPlanName, viewLabel]), 'PaymentHistory')">{{getGenericCopy$('payment.view.history') | async}}</a>
            }
        </div>
    </div>
</div>
